import { render, staticRenderFns } from "./PassReset.vue?vue&type=template&id=2a7f102a&scoped=true"
import script from "./PassReset.vue?vue&type=script&lang=js"
export * from "./PassReset.vue?vue&type=script&lang=js"
import style0 from "./PassReset.vue?vue&type=style&index=0&id=2a7f102a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7f102a",
  null
  
)

export default component.exports